{
  "version": 1,
  "asset_id": "22a3694b-6596-4634-a118-f234ca871cd4",
  "project_id": "ba939065-ecb3-4567-a218-3200eee84f15",
  "url": "/__l5e/assets-v1/22a3694b-6596-4634-a118-f234ca871cd4/CTR7SecretsGuide.pdf",
  "r2_key": "a/v1/ba939065-ecb3-4567-a218-3200eee84f15/22a3694b-6596-4634-a118-f234ca871cd4/CTR7SecretsGuide.pdf",
  "original_filename": "CTR7SecretsGuide.pdf",
  "size": 136101,
  "content_type": "application/pdf",
  "created_at": "2026-06-30T15:40:11Z"
}
